
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { dateParserLong } from '@/helpers/dateParserHelper';
import Card from '@/components/Card.vue';
import { InscriptionAssembleeDTO } from '@/types/store/DTO/InscriptionAssembleeDTO';
import JsonCSV from 'vue-json-csv';
export default defineComponent({
  name: 'ListeInscriptionsAssemblee',
  components: { DataTable, Column, Card, JsonCSV },
  data() {
    return {
      search: '',
      inscriptionsList: new Array<InscriptionAssembleeDTO>(),
      inscriptionsListCopie: new Array<InscriptionAssembleeDTO>(),
      ico: 'far',
      selectedInscription: {} as InscriptionAssembleeDTO,
      minDate: null,
      maxDate: null,
      isDisabled: true,
    };
  },
  methods: {
    getInscriptionsWithDates() {
      if (this.minDate != null && this.maxDate != null) {
        if (this.minDate > this.maxDate) {
          return;
        }
        this.$loading.startLoading();
        this.$store
          .dispatch('Rapports/inscriptionsAdminWithDates', {
            minDate: this.minDate,
            maxDate: this.maxDate,
          })
          .then((data: Array<InscriptionAssembleeDTO>) => {
            if (data != undefined) {
              this.inscriptionsList = data;
              this.inscriptionsListCopie = data;
            } else {
              this.inscriptionsList = new Array<InscriptionAssembleeDTO>();
              this.inscriptionsListCopie = new Array<InscriptionAssembleeDTO>();
            }
            this.$loading.stopLoading();
          })
          .catch(() => {
            this.$loading.stopLoading();
          })
          .finally(() => {
            this.$loading.stopLoading();
          });
      }
    },
    checkDisabled() {
      if (
        this.minDate == null ||
        this.maxDate == null ||
        this.minDate == '' ||
        this.maxDate == ''
      ) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    dateParserLong(date: string) {
      return dateParserLong(date);
    },
    getInscriptions() {
      this.$loading.startLoading();
      this.$store
        .dispatch('InscriptionAssemblee/getAllInscriptionsAssembleeByAdmin')
        .then((data: Array<InscriptionAssembleeDTO>) => {
          if (data != undefined) {
            this.inscriptionsList = data;
            this.inscriptionsListCopie = data;
          } else {
            this.inscriptionsList = new Array<InscriptionAssembleeDTO>();
            this.inscriptionsListCopie = new Array<InscriptionAssembleeDTO>();
          }
          this.$loading.stopLoading();
        })
        .catch(() => {
          this.$loading.stopLoading();
        })
        .finally(() => {
          this.$loading.stopLoading();
        });
    },
  },
  created() {
    this.getInscriptions();
  },
});
